import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';

import { InactiveSessionsDialogComponent } from '../modules/inactive-sessions/components/inactive-sessions-dialog.component';
import { AuthService } from './auth.service';

export const closeModalEvent = 'timeOut';
export const sessionExpirationTimeKey = 'SESSION-EXPIRATION-TIME';

@Injectable({
  providedIn: 'root',
})
export class AutoLogoutService {
  private intervalId: any;
  private showModal = false;
  private ref: MatDialogRef<InactiveSessionsDialogComponent, any>;
  private checkTime = 2000; // 2 second

  constructor(private dialog: MatDialog, public authService: AuthService) {
    this.startSessionTimer();
  }

  private startSessionTimer(): void {
    this.stopSessionTimer();

    this.intervalId = setInterval(() => this.logSessionTime(), this.checkTime);
  }

  private stopSessionTimer(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }

  private logSessionTime(): void {
    const expirationTime = Number(
      localStorage.getItem(sessionExpirationTimeKey),
    );
    if (!expirationTime) {
      return;
    }

    const remainingTime = expirationTime - Math.floor(Date.now() / 1000);

    if (remainingTime <= 0) {
      if (this.ref) {
        this.ref.close(closeModalEvent);
      }
      this.stopSessionTimer();
      return;
    }

    if (remainingTime < 60 && !this.showModal) {
      this.openInactiveModal();
      this.showModal = true;
      return;
    }

    if (remainingTime > 60 && this.ref) {
      this.ref.close();
    }
  }

  private openInactiveModal(): void {
    this.ref = this.dialog.open(InactiveSessionsDialogComponent, {
      maxWidth: '713px !impotent',
      height: '300px',
      panelClass: ['auto-logout'],
    });

    this.ref.afterClosed().subscribe(async (res) => {
      this.showModal = false;
      if (res === closeModalEvent) {
        await this.authService.logout();
        this.dialog.closeAll();
        return;
      }
      await firstValueFrom(this.authService.loadSession());
    });
  }
}
